import { api } from "@/builders/axios";

export function onboard_staffs(data: {
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  staff_id: string;
  location: string;
}) {
  return api.post("/callbacks/onboard-staffs", data).then(({ data }) => data);
}

export const callbacks = {
  onboard_staffs,
};
